// Navbar.js

import React, { useState, useEffect } from "react"
import { Nav, NavButton, Scroll, LanguageSwitch, Arrow, ArrowRotated, ArrowDown, ShareBox, Close, Wa, Email, Fb, Twitter} from "./NavbarElements"
import Language from "../language"

import scrollTo from 'gatsby-plugin-smoothscroll';

import {  FormattedMessage  } from "gatsby-plugin-react-intl"

const Navbar = () => {
  const [scroll, setScroll] = useState(false)
  const [navbarOpen, setNavbarOpen] = useState(false)

  const changeNav = () => {
    if (window.scrollY >= 80) {
      setScroll(true)
    } else {
      setScroll(false)
    }
  }

  useEffect(() => {
    changeNav()
    window.addEventListener("scroll", changeNav)
  }, [])

  return (
    <>
      <Nav id="header">
        <NavButton onClick={() => scrollTo('#galerij')}>
          <Arrow />
          <span><FormattedMessage id="button1" /></span>
        </NavButton>
        <NavButton navbarOpen={navbarOpen} onClick={() => setNavbarOpen(!navbarOpen)}>
          <ArrowRotated />
          <span><FormattedMessage id="button2" /></span>
        </NavButton>
        {navbarOpen ? (
          <ShareBox>
            <div className="share-container">
              <a className="share-button" href="https://www.facebook.com/sharer/sharer.php?u=https://mienskip.heleenkater.nl" target="_blank">
                <Fb />
              </a>
              <a className="share-button" href="https://twitter.com/intent/tweet/?text=Mienskip Burum:&url=https://mienskip.heleenkater.nl" target="_blank">
                <Twitter />
              </a>
              <a className="share-button" href="https://api.whatsapp.com/send?text=%E2%80%9CVerbonden%20met%20de%20plek%20waar%20ik%20woon%2C%20met%20de%20mensen%20om%20me%20heen%2C%20wonen%2C%20beleven%20en%20waarderen.%E2%80%9D%0Ahttps%3A%2F%2Fmienskip.heleenkater.nl" target="_blank">
                <Wa />
              </a>
              <div className="share-button" navbarOpen={navbarOpen} onClick={() => setNavbarOpen(!navbarOpen)}>
                <Close />
              </div>
            </div>
          </ShareBox>
      ) : (
          <ShareBox open>
      
          </ShareBox>
      )}
        <Scroll active={scroll} onClick={() => scrollTo('#start')}>
          <ArrowDown />
          Scroll
        </Scroll>
        <LanguageSwitch active={scroll}>
          <Language />
        </LanguageSwitch>
      </Nav>
    </>
  )
}

export default Navbar